<template>
  <v-card>
    <v-toolbar dense color="indigo">
      <v-toolbar-title class="white--text">
        Componenti Distinta Base
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Aggiungi a distinte selezionate -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiungiADistinte"
            color="blue-grey lighten-5"
            small
            v-on="on"
            v-bind="attrs"
          >
            <v-icon color="primary">mdi-plus-box-multiple</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi a Distinte Selezionate</span>
      </v-tooltip>

      <!-- Sostituisci a distinte selezionate -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="sostituisciADistinte"
            small
            v-on="on"
            v-bind="attrs"
          >
            <v-icon color="primary">mdi-sync</v-icon>
          </v-btn>
        </template>
        <span>Sostituisci a Distinte Selezionate</span>
      </v-tooltip>

      <!-- Elimina da distinte selezionate -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="eliminaDaDistinte" small v-on="on" v-bind="attrs">
            <v-icon color="primary">mdi-minus-box-multiple</v-icon>
          </v-btn>
        </template>
        <span>Elimina da Distinte Selezionate</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Aggiungi componente alla lista -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickAggiungiComponente"
            small
            v-on="on"
            v-bind="attrs"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Componente in Lista</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="min-height: 300px">
      <!-- Banner di avviso nessun componente -->
      <div
        style="
          border: 1px solid black;
          display: inline-block;
          font-size: 15px;
          padding: 15px;
        "
        v-if="items_componenti.length === 0"
      >
        Nessun componente è attualmente selezionato.
      </div>
      <!-- Lista dei componenti in distinta -->
      <v-data-table
        :headers="headers_componenti"
        :items="items_componenti"
        v-else
      >
        <!-- Colonna della quantità -->
        <template v-slot:[`item.quantita`]="{ item }">
          <v-text-field
            dense
            min="0"
            style="display: inline-block; max-width: 100px"
            type="number"
            v-model="item.quantita"
          ></v-text-field>
        </template>

        <!-- Colonna di eliminazione -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickEliminaComponente(item)"
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina Componente dalla Lista</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog di aggiunta componente a distinta -->
    <v-dialog persistent v-model="dialog_aggiungi_componente" width="700">
      <v-card>
        <v-toolbar dense class="indigo">
          <v-toolbar-title class="white--text">Selezione</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiComponenti" small v-on="on" v-bind="attrs">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Componente</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialog_aggiungi_componente = false" small>
                <v-icon class="" v-on="on" v-bind="attrs" color="red">
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" class="mb-0 pb-0">
                <v-text-field
                  dense
                  label="Cod. Articolo"
                  outlined
                  style="border-radius: 1px; max-width: 300px"
                  type="text"
                  v-model="cod_articolo_search"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="searchComponente" small>
                          <v-icon v-on="on" v-bind="attrs" color="primary">
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Cerca</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-data-table
                  :headers="headers_aggiunta"
                  :items="items_aggiunta"
                >
                  <!-- Titolo della tabella -->
                  <template v-slot:top>
                    <v-toolbar dense class="indigo">
                      <v-toolbar-title class="white--text">
                        Componenti
                      </v-toolbar-title>
                    </v-toolbar>
                  </template>

                  <!-- Colonna della quantità -->
                  <template v-slot:[`item.quantita`]="{ item }">
                    <v-text-field
                      dense
                      min="0"
                      style="display: inline-block; max-width: 100px"
                      type="number"
                      v-model="item.quantita"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    SnackbarQV,
  },
  props: {
    items_ids: { type: Array, default: () => [] },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_search: "",

      // Modal
      caricamento_dati: false,
      dialog_aggiungi_componente: false,

      // Array
      headers_aggiunta: [
        { text: "Quantità", value: "quantita", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Des. Articolo", value: "des_articolo", sortable: false },
      ],
      headers_componenti: [
        { text: "Quantità", value: "quantita", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Des. Articolo", value: "des_articolo", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      items_aggiunta: new Array(),
      items_componenti: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiADistinte() {
      // Controllo che ci siano degli articoli selezionati.
      if (this.items_ids.length > 0) {
        this.$refs.SnackbarQV.print(
          "success",
          "Selezionare degli articoli da modificare."
        );

        return;
      }

      // Preparo la stringa di id da mandare nella request.
      let id_string = "";
      this.items_ids.forEach((id) => {
        id_string += id + ",";
      });

      id_string.slice(0, -1);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "aggiungiadistinte",
          token: localStorage.user_token,
          lista_id: id_string,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Distinte aggiornate.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    aggiungiComponenti() {
      console.log("entrato");
      let chk_recursione = false;
      let chk_components = false;

      this.items_aggiunta
        .filter((e) => e.quantita > 0)
        .forEach((e) => {
          // Controllo che il componente non sia già presente.
          this.items_componenti.forEach((c) => {
            if (c.id_articolo === e.id_articolo) {
              chk_components = true;
            }
          });

          // Controllo che il componente non sia recursivo.
          this.items_ids.forEach((id) => {
            if (id == e.id_articolo) {
              chk_recursione = true;
            }
          });
        });

      /* Se qualche controllo è andato storto
       * stampo una snackbar di avviso. */
      if (chk_components === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Alcuni componenti sono già presenti."
        );
        return;
      } else if (chk_recursione === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La distinta base non può contenere elementi recursivi."
        );
        return;
      }

      // Se va tutto bene, registro le aggiunte.
      this.items_aggiunta
        .filter((e) => e.quantita > 0)
        .forEach((e) => {
          this.items_componenti.push(Object.assign({}, e));
        });

      // Chiudo il dialog e resetto l'array delle aggiunte.
      this.dialog_aggiungi_componente = false;
      this.items_aggiunta = new Array();
    },
    clickAggiungiComponente() {
      this.dialog_aggiungi_componente = true;
    },
    clickEliminaComponente(arg) {
      let idx = -1;
      for (let i = 0; i < this.items_componenti.length; i++) {
        if (this.items_componenti[i].cod_articolo === arg.cod_articolo) {
          idx = i;
        }
      }

      if (idx > -1) {
        this.items_componenti.splice(idx, 1);
      }
    },
    eliminaDaDistinte() {
      // Controllo che ci siano degli articoli selezionati.
      if (this.items_ids.length > 0) {
        this.$refs.SnackbarQV.print(
          "success",
          "Selezionare degli articoli da modificare."
        );

        return;
      }

      // Preparo la stringa di id da mandare nella request.
      let id_string = "";
      this.items_ids.forEach((id) => {
        id_string += id + ",";
      });

      id_string.slice(0, -1);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "eliminadadistinte",
          token: localStorage.user_token,
          lista_id: id_string,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_componenti;
            this.$refs.SnackbarQV.print("success", "Distinte aggiornate.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    searchComponente() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
          cod_articolo: this.cod_articolo_search,
          validita: 1,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            /* Se ho dei riscontri li registro, altrimenti
             * stampo una snackbar di avviso. */
            if (res.data.lista.length > 0) {
              res.data.lista.forEach((e) => {
                e.quantita = 0;
              });

              this.items_aggiunta = res.data.lista;
            } else {
              this.$refs.SnackbarQV.print("success", "Distinte aggiornate.");
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    sostituisciADistinte() {
      // Controllo che ci siano degli articoli selezionati.
      if (this.items_ids.length > 0) {
        this.$refs.SnackbarQV.print(
          "success",
          "Selezionare degli articoli da modificare."
        );

        return;
      }

      // Preparo la stringa di id da mandare nella request.
      let id_string = "";
      this.items_ids.forEach((id) => {
        id_string += id + ",";
      });

      id_string.slice(0, -1);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "sostituisciadistinte",
          token: localStorage.user_token,
          lista_id: id_string,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Distinte aggiornate.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>